import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
export const TracexIntegrationStatusEnum = z.enum([
    'unknown',
    'enabled',
    'disabled',
]);
export const TracexIntegrationResponseSchema = z.object({
    status: TracexIntegrationStatusEnum,
    apiToken: z.string().nullable(),
});
export const UpdateTracexIntegrationBodySchema = z.object({
    status: TracexIntegrationStatusEnum,
    apiToken: z.string().optional(),
});
export const integrationContract = c.router({
    getTracexIntegration: {
        method: 'GET',
        path: '/integrations/tracex',
        responses: {
            200: TracexIntegrationResponseSchema,
        },
    },
    updateTracexIntegration: {
        method: 'PUT',
        path: '/integrations/tracex',
        body: UpdateTracexIntegrationBodySchema,
        responses: {
            200: TracexIntegrationResponseSchema,
        },
    },
});
//# sourceMappingURL=integration.js.map